import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DepartmentService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of department.
     *
     * @datatask 2226
     * @datataskName sp_ws_p2_w_departments_view
     * @param params the businessco to get departments of, if not all.
     * @returns promise containing list of departments.
     */
    public getDepartments(params: GetDepartmentsParams): Promise<DepartmentItem[]> {
        return this.datatask.Post(2226, params);
    }
}

export interface GetDepartmentsParams {
    businessco_no?: string | number;
}

export interface DepartmentItem {
    item_id: string;
    item_name: string;
    item_state: string;
    item_path: string;
    item_parms: string;
    orderby: string;
}
